module.exports = __webpack_public_path__ + "media/images/icons/notification_logs-4210496205736d4232a448d1211e222a.svg";